// Class: haxe.xml._Fast.NodeListAccess

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $import = require("./../../../import_stub").default;
function List() {return require("./../../../List");}
function haxe_xml_Fast() {return require("./../../../haxe/xml/Fast");}

// Constructor

var NodeListAccess = function(x) {
	this.__x = x;
}

// Meta

NodeListAccess.__name__ = ["haxe","xml","_Fast","NodeListAccess"];
NodeListAccess.prototype = {
	resolve: function(name) {
		var l = new (List().default)();
		var x = this.__x.elementsNamed(name);
		while(x.hasNext()) {
			var x1 = x.next();
			l.add(new (haxe_xml_Fast().default)(x1));
		}
		return l;
	}
};
NodeListAccess.prototype.__class__ = NodeListAccess.prototype.constructor = $hxClasses["haxe.xml._Fast.NodeListAccess"] = NodeListAccess;

// Init



// Statics




// Export

exports.default = NodeListAccess;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/haxe/xml/_Fast/NodeListAccess.js
// module id = 308
// module chunks = 0